import { apiClient, handleResp } from './utils';

export default {
  setEmbed(dataInput) {
    return handleResp(apiClient().post('/setup_embed', dataInput));
  },
  createAccountEmbed(dataInput) {
    return handleResp(apiClient().post('/create_account_embed', dataInput));
  },
  getAccountEmbed(accountId) {
    return handleResp(apiClient().post('/account_embeds?id=' + accountId));
  },
};
